import { useState } from "react";
import { Eye } from "lucide-react";

export default function ExplicitBlur({ isExplicit, src, alt, className = "", testId, fit = "cover" }) {
    const [revealed, setRevealed] = useState(!isExplicit);

    return (
        <div className={`relative overflow-hidden group ${className}`}>
            <img
                src={src}
                alt={alt}
                className={`w-full h-full ${fit === "contain" ? "object-contain" : "object-cover"} reveal-fade`}
                style={{
                    filter: revealed ? "none" : "blur(40px)",
                    transform: revealed ? "scale(1)" : "scale(1.1)",
                    transition: "filter 0.6s ease, transform 0.8s ease",
                }}
                loading="lazy"
            />
            {!revealed && (
                <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setRevealed(true); }}
                    className="absolute inset-0 flex flex-col items-center justify-center bg-[#1A1A1A]/60 hover:bg-[#1A1A1A]/70 backdrop-blur-sm transition-colors z-10"
                    data-testid={testId || "explicit-reveal-btn"}
                >
                    <Eye className="w-6 h-6 text-white mb-3" />
                    <span className="text-[10px] tracking-[0.3em] text-white uppercase">Click to Reveal</span>
                    <span className="text-[10px] tracking-[0.2em] text-white/70 uppercase mt-1">Explicit Content</span>
                </button>
            )}
        </div>
    );
}
